define(["jquery"], function($) {
	
	var escaped_one_to_xml_special_map = {
	    '&amp;': '&',
	    '&quot;': '"',
	    '&lt;': '<',
	    '&gt;': '>'
	};
	
	function decodeXml(string) {
	    return string.replace(/(&quot;|&lt;|&gt;|&amp;)/g,
	        function(str, item) {
	            return escaped_one_to_xml_special_map[item];
	    	}
	    );
	}
	
	function safeString(s) {
		if (typeof s === 'string') {
			return s;
		}
		return '';
	}
	
	return {
		decodeXml: decodeXml,
		safeString: safeString
	};
});